/**
* @class Ext
*
* The Ext namespace (global object) encapsulates all classes, singletons, and
* utility methods provided by Sencha's libraries.
*
* Most user interface Components are at a lower level of nesting in the namespace,
* but many common utility functions are provided as direct properties of the Ext namespace.
*
* Also many frequently used methods from other classes are provided as shortcuts
* within the Ext namespace. For example {@link Ext#getCmp Ext.getCmp} aliases
* {@link Ext.ComponentManager#get Ext.ComponentManager.get}.
*
* Many applications are initiated with {@link Ext#onReady Ext.onReady} which is
* called once the DOM is ready. This ensures all scripts have been loaded,
* preventing dependency issues. For example:
*
*     Ext.onReady(function(){
*         new Ext.Component({
*             renderTo: document.body,
*             html: 'DOM ready!'
*         });
*     });
*
* For more information about how to use the Ext classes, see:
*
* - <a href="http://www.sencha.com/learn/">The Learning Center</a>
* - <a href="http://www.sencha.com/learn/Ext_FAQ">The FAQ</a>
* - <a href="http://www.sencha.com/forum/">The forums</a>
*
* @singleton
*/
Ext.apply(Ext, {
    userAgent: navigator.userAgent.toLowerCase()
});

// for old browsers
window.undefined = window.undefined;

/**
* @class Ext
*/
(function () {
    /*
    FF 3.6      - Mozilla/5.0 (Windows; U; Windows NT 5.1; en-US; rv:1.9.2.17) Gecko/20110420 Firefox/3.6.17
    FF 4.0.1    - Mozilla/5.0 (Windows NT 5.1; rv:2.0.1) Gecko/20100101 Firefox/4.0.1
    FF 5.0      - Mozilla/5.0 (Windows NT 6.1; WOW64; rv:5.0) Gecko/20100101 Firefox/5.0

    IE6         - Mozilla/4.0 (compatible; MSIE 6.0; Windows NT 5.1; SV1;)
    IE7         - Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 5.1; SV1;)
    IE8         - Mozilla/4.0 (compatible; MSIE 8.0; Windows NT 5.1; Trident/4.0)
    IE9         - Mozilla/5.0 (compatible; MSIE 9.0; Windows NT 6.1; WOW64; Trident/5.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; Media Center PC 6.0; .NET4.0C; .NET4.0E)

    Chrome 11   - Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/534.24 (KHTML, like Gecko) Chrome/11.0.696.60 Safari/534.24

    Safari 5    - Mozilla/5.0 (Windows; U; Windows NT 6.1; en-US) AppleWebKit/533.21.1 (KHTML, like Gecko) Version/5.0.5 Safari/533.21.1

    Opera 11.11 - Opera/9.80 (Windows NT 6.1; U; en) Presto/2.8.131 Version/11.11
    */
    var check = function (regex) {
        return regex.test(Ext.userAgent);
    },
        isStrict = document.compatMode == "CSS1Compat",
        version = function (is, regex) {
            var m;
            return (is && (m = regex.exec(Ext.userAgent))) ? parseFloat(m[1]) : 0;
        },
        docMode = document.documentMode,
        isOpera = check(/opera/),
        isOpera10_5 = isOpera && check(/version\/10\.5/),
        isChrome = check(/\bchrome\b/),
        isWebKit = check(/webkit/),
        isSafari = !isChrome && check(/safari/),
        isSafari2 = isSafari && check(/applewebkit\/4/), // unique to Safari 2
        isSafari3 = isSafari && check(/version\/3/),
        isSafari4 = isSafari && check(/version\/4/),
        isSafari5_0 = isSafari && check(/version\/5\.0/),
        isSafari5 = isSafari && check(/version\/5/),
        isIE = !isOpera && check(/msie/),
        isIE7 = isIE && ((check(/msie 7/) && docMode != 8 && docMode != 9) || docMode == 7),
        isIE8 = isIE && ((check(/msie 8/) && docMode != 7 && docMode != 9) || docMode == 8),
        isIE9 = isIE && ((check(/msie 9/) && docMode != 7 && docMode != 8) || docMode == 9),
        isIE6 = isIE && check(/msie 6/),
        isGecko = !isWebKit && check(/gecko/),
        isGecko3 = isGecko && check(/rv:1\.9/),
        isGecko4 = isGecko && check(/rv:2\.0/),
        isGecko5 = isGecko && check(/rv:5\./),
        isGecko10 = isGecko && check(/rv:10\./),
        isFF3_0 = isGecko3 && check(/rv:1\.9\.0/),
        isFF3_5 = isGecko3 && check(/rv:1\.9\.1/),
        isFF3_6 = isGecko3 && check(/rv:1\.9\.2/),
        isWindows = check(/windows|win32/),
        isMac = check(/macintosh|mac os x/),
        isLinux = check(/linux/),
        scrollbarSize = null,
        chromeVersion = version(true, /\bchrome\/(\d+\.\d+)/),
        firefoxVersion = version(true, /\bfirefox\/(\d+\.\d+)/),
        ieVersion = version(isIE, /msie (\d+\.\d+)/),
        operaVersion = version(isOpera, /version\/(\d+\.\d+)/),
        safariVersion = version(isSafari, /version\/(\d+\.\d+)/),
        webKitVersion = version(isWebKit, /webkit\/(\d+\.\d+)/),
        isSecure = /^https/i.test(window.location.protocol),
        nullLog;

    Ext.apply(Ext, {

        isStrict: isStrict,

        isIEQuirks: isIE && !isStrict,

        /**
        * True if the detected browser is Opera.
        * @type Boolean
        */
        isOpera: isOpera,

        /**
        * True if the detected browser is Opera 10.5x.
        * @type Boolean
        */
        isOpera10_5: isOpera10_5,

        /**
        * True if the detected browser uses WebKit.
        * @type Boolean
        */
        isWebKit: isWebKit,

        /**
        * True if the detected browser is Chrome.
        * @type Boolean
        */
        isChrome: isChrome,

        /**
        * True if the detected browser is Safari.
        * @type Boolean
        */
        isSafari: isSafari,

        /**
        * True if the detected browser is Safari 3.x.
        * @type Boolean
        */
        isSafari3: isSafari3,

        /**
        * True if the detected browser is Safari 4.x.
        * @type Boolean
        */
        isSafari4: isSafari4,

        /**
        * True if the detected browser is Safari 5.x.
        * @type Boolean
        */
        isSafari5: isSafari5,

        /**
        * True if the detected browser is Safari 5.0.x.
        * @type Boolean
        */
        isSafari5_0: isSafari5_0,


        /**
        * True if the detected browser is Safari 2.x.
        * @type Boolean
        */
        isSafari2: isSafari2,

        /**
        * True if the detected browser is Internet Explorer.
        * @type Boolean
        */
        isIE: isIE,

        /**
        * True if the detected browser is Internet Explorer 6.x.
        * @type Boolean
        */
        isIE6: isIE6,

        /**
        * True if the detected browser is Internet Explorer 7.x.
        * @type Boolean
        */
        isIE7: isIE7,

        /**
        * True if the detected browser is Internet Explorer 8.x.
        * @type Boolean
        */
        isIE8: isIE8,

        /**
        * True if the detected browser is Internet Explorer 9.x.
        * @type Boolean
        */
        isIE9: isIE9,

        /**
        * True if the detected browser uses the Gecko layout engine (e.g. Mozilla, Firefox).
        * @type Boolean
        */
        isGecko: isGecko,

        /**
        * True if the detected browser uses a Gecko 1.9+ layout engine (e.g. Firefox 3.x).
        * @type Boolean
        */
        isGecko3: isGecko3,

        /**
        * True if the detected browser uses a Gecko 2.0+ layout engine (e.g. Firefox 4.x).
        * @type Boolean
        */
        isGecko4: isGecko4,

        /**
        * True if the detected browser uses a Gecko 5.0+ layout engine (e.g. Firefox 5.x).
        * @type Boolean
        */
        isGecko5: isGecko5,

        /**
        * True if the detected browser uses a Gecko 5.0+ layout engine (e.g. Firefox 5.x).
        * @type Boolean
        */
        isGecko10: isGecko10,

        /**
        * True if the detected browser uses FireFox 3.0
        * @type Boolean
        */
        isFF3_0: isFF3_0,

        /**
        * True if the detected browser uses FireFox 3.5
        * @type Boolean
        */
        isFF3_5: isFF3_5,

        /**
        * True if the detected browser uses FireFox 3.6
        * @type Boolean
        */
        isFF3_6: isFF3_6,

        /**
        * True if the detected browser uses FireFox 4
        * @type Boolean
        */
        isFF4: 4 <= firefoxVersion && firefoxVersion < 5,

        /**
        * True if the detected browser uses FireFox 5
        * @type Boolean
        */
        isFF5: 5 <= firefoxVersion && firefoxVersion < 6,

        /**
        * True if the detected browser uses FireFox 10
        * @type Boolean
        */
        isFF10: 10 <= firefoxVersion && firefoxVersion < 11,

        /**
        * True if the detected browser uses FireFox 10 or greater
        * @type Boolean
        */
        isgtFF10: 10 <= firefoxVersion,

        /**
        * True if the detected platform is Linux.
        * @type Boolean
        */
        isLinux: isLinux,

        /**
        * True if the detected platform is Windows.
        * @type Boolean
        */
        isWindows: isWindows,

        /**
        * True if the detected platform is Mac OS.
        * @type Boolean
        */
        isMac: isMac,

        /**
        * The current version of Chrome (0 if the browser is not Chrome).
        * @type Number
        */
        chromeVersion: chromeVersion,

        /**
        * The current version of Firefox (0 if the browser is not Firefox).
        * @type Number
        */
        firefoxVersion: firefoxVersion,

        /**
        * The current version of IE (0 if the browser is not IE). This does not account
        * for the documentMode of the current page, which is factored into {@link #isIE7},
        * {@link #isIE8} and {@link #isIE9}. Thus this is not always true:
        *
        *     Ext.isIE8 == (Ext.ieVersion == 8)
        *
        * @type Number
        */
        ieVersion: ieVersion,

        /**
        * The current version of Opera (0 if the browser is not Opera).
        * @type Number
        */
        operaVersion: operaVersion,

        /**
        * The current version of Safari (0 if the browser is not Safari).
        * @type Number
        */
        safariVersion: safariVersion,

        /**
        * The current version of WebKit (0 if the browser does not use WebKit).
        * @type Number
        */
        webKitVersion: webKitVersion,

        /**
        * True if the page is running over SSL
        * @type Boolean
        */
        isSecure: isSecure,

        /*
        * @property {Boolean} useShims
        * By default, Ext intelligently decides whether floating elements should be shimmed.
        * If you are using flash, you may want to set this to true.
        */
        useShims: isIE6
    });
} ());
